<template lang="pug">
  v-text-field.input-group--focused(
    autocomplete="on",
    v-bind="$attrs",
    :append-icon="show ? 'fa-eye' : 'fa-eye-slash'", :rules='[rules.required]',
    :type="show ? 'text' : 'password'",
    :value='value',
    @click:append='show = !show',
    @input="$emit('update:value', $event)",
    @keydown.stop="keydown",
  )
</template>

<script>
export default {
  props: {
    value: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
    },
  },

  data: () => ({
    show: false,
  }),

  computed: {
    rules() {
      return {
        required: value => !!value || `${this.$attrs.label} is required`,
      };
    },
  },

  methods: {
    keydown(e) {
      const key = e.charCode || e.keyCode || 0;

      if (key === 13) {
        event.preventDefault();
        this.$emit('enter');
      }
    },
  },
};
</script>
